export default __webpack_public_path__ + "static/media/announcement-logo.7fc9e9b7.svg";